import React from 'react';
import { FadeIn } from './FadeIn';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'El invierno pasado mi hija tuvo 3 anginas y 2 otitis. Este invierno, con el protocolo, tuvo un resfriado leve de 3 días. Mi pediatra me preguntó qué había cambiado.',
    name: 'Valentina R.',
    context: 'mamá de Lucía, 4 años',
    initial: 'V'
  }, {
    quote: "Siempre pensé que era 'mala suerte' que mi hijo se enfermara tanto. Ahora entiendo que era la microbiota. El shot de dragón se convirtió en un ritual que él mismo me pide.",
    name: 'Camila M.',
    context: 'mamá de Tomás, 3 años',
    initial: 'C'
  }, {
    quote: 'Lo que más me cambió fue el Protocolo SOS. Saber exactamente qué hacer en las primeras 2 horas me quitó el pánico nocturno de encima. Es como tener un manual de emergencias.',
    name: 'Florencia B.',
    context: 'mamá de dos niños, 2 y 5 años',
    initial: 'F'
  }, {
    quote: "Mi hijo tiene tendencia a las alergias y los mocos crónicos. Después de 6 semanas de protocolo, el alergólogo notó una mejora 'significativa'. Solo cambiamos la alimentación.",
    name: 'Andrea L.',
    context: 'mamá de Mateo, 5 años',
    initial: 'A'
  }];
  return <section className="py-16 md:py-24 px-4 bg-cream overflow-hidden" data-id="element-447">
      <div className="max-w-6xl mx-auto" data-id="element-448">
        <FadeIn data-id="element-449">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-green-deep text-center mb-12" data-id="element-450">
            💬 LO QUE OTRAS MAMÁS YA ESTÁN VIVIENDO
          </h2>
        </FadeIn>

        {/* Mobile: Horizontal scroll, Desktop: Grid */}
        <div className="flex overflow-x-auto md:grid md:grid-cols-2 lg:grid-cols-4 gap-6 pb-8 -mx-4 px-4 md:mx-0 md:px-0 hide-scrollbar snap-x snap-mandatory" data-id="element-451">
          {testimonials.map((t, index) => <FadeIn key={index} delay={index * 0.1} className="min-w-[85vw] md:min-w-0 snap-center" data-id="element-452">
              <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-green-mint/20 h-full flex flex-col" data-id="element-453">
                <div className="flex gap-1 mb-4 text-orange-warm" data-id="element-454">
                  ⭐⭐⭐⭐⭐
                </div>
                <p className="text-text-main/80 italic mb-6 flex-1 text-sm md:text-base" data-id="element-455">
                  "{t.quote}"
                </p>
                <div className="flex items-center gap-3 mt-auto" data-id="element-456">
                  <div className="w-10 h-10 rounded-full bg-green-mint/30 text-green-deep flex items-center justify-center font-bold font-heading" data-id="element-457">
                    {t.initial}
                  </div>
                  <div data-id="element-458">
                    <p className="font-bold text-text-main text-sm" data-id="element-459">{t.name}</p>
                    <p className="text-xs text-text-main/60" data-id="element-460">{t.context}</p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}